import { action, observable, computed } from 'mobx';
import Alert from 'react-s-alert';

import { Variables, AppManager, App } from 'core';

import { FormStore } from 'libs/forms/app';
import { ProfileModel, ProfileApp } from 'apps/profile/app';
import { ProfileCheckQuery } from 'apps/profile/gql';
import { conf } from 'apps/profile/settings/config.yaml';
import { routerStore } from 'core/routing';

class ManageEmailsApp extends App {
  static registryName = 'ManageEmailsApp';
  @observable newEmail = '';
  init() {
    this.form = new FormStore(this, conf, 'newEmailForm');
  }

  @action Submit = () => {
    this.manager.Submit({
      onSuccess: this.onSuccess,
    });
  };

  @action onSuccess = () => {
    setTimeout(() => {
      Alert.success('Password changed successfully!');
    }, 300);
  };
}

export class ManageEmailsAppManager extends AppManager {
  static registryName = 'ManageEmailsAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.app = new ManageEmailsApp(this, {});
    this.app.init();
    // TODO: Do query for Users emails
  }

  @action Submit = (/* options */) => {
    this.mutations
      .push
      // RequestResetPasswordMutation.New(this.resetPasswordApp.submitValue, options)
      ();
  };
}

export class RouterAppManager extends AppManager {
  static registryName = 'RouterAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('profile', ProfileApp);
    this.checkQuery = new ProfileCheckQuery(this, {
      queryKey: 'checkProfile',
      onSysErr: this.onError,
      variables: new Variables({
        username: () => routerStore.route.params.spacePath,
      }),
    });
    this.checkQuery.process(
      result => result && ProfileModel.Load(result),
      this.UpdateProfile,
    );
    this.checkQuery.query();
  }

  @action UpdateProfile = profile => {
    if (profile) {
      this.profile = profile;
    }
  };

  @computed get isAllowed() {
    return this.profile && this.profile.canUpdate;
  }

  @computed get notFound() {
    return this.checkQuery.notFound;
  }

  @computed get loading() {
    return this.checkQuery.loading;
  }
}
